import { render, staticRenderFns } from "./CourseMetodics.vue?vue&type=template&id=96469c04&scoped=true&"
import script from "./CourseMetodics.vue?vue&type=script&lang=js&"
export * from "./CourseMetodics.vue?vue&type=script&lang=js&"
import style0 from "./CourseMetodics.vue?vue&type=style&index=0&id=96469c04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96469c04",
  null
  
)

export default component.exports